import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { CookieService } from 'ngx-cookie-service';
import { ReflexEnvironment as ENV } from '@smartsoftware/reflex-core';

@Component({
	templateUrl: './view.html',
	styleUrls: ['./view.scss'],
})
export class OktaView implements OnInit {
	constructor(
		protected auth: OidcSecurityService,
		private cookieService: CookieService
	) {
	}

	private okta_username = '';
	private okta_client = '';
	private okta_attemptId = '';
	private okta_error = '';
	private oktaClient : any;

	private login_hint = 'from=Okta';

	async ngOnInit() {
		if(this.cookieService.get('okta_username')) {
			this.okta_username = this.cookieService.get('okta_username');
			this.login_hint += ',username=' + this.okta_username;
			this.cookieService.delete('okta_username', '/', '.firstlegal.com');
		}

		if(this.cookieService.get('okta_attemptId')) {
			this.okta_attemptId = this.cookieService.get('okta_attemptId');
			this.login_hint += ',attemptId=' + this.okta_attemptId;
			this.cookieService.delete('okta_attemptId', '/', '.firstlegal.com');
		}

		if(this.cookieService.get('okta_client')) {
			this.okta_client = this.cookieService.get('okta_client');
			this.login_hint += ',client=' + this.okta_client;
			this.cookieService.delete('okta_client', '/', '.firstlegal.com');
			this.oktaClient = this.getOktaClient(this.okta_client);
			this.login_hint += ',tenantId=' + this.oktaClient.tenantId;
		}

		if(this.cookieService.get('okta_error')) {
			this.okta_error = this.cookieService.get('okta_error');
			this.cookieService.delete('okta_error', '/', '.firstlegal.com');
			let config = this.auth.getConfiguration();
			if(config && config.redirectUrl && config.unauthorizedRoute) {
				window.localStorage.setItem('okta_error', this.okta_error);
				window.location.href = config.redirectUrl + config.unauthorizedRoute;
			}
		}

		if(!this.okta_error && this.okta_username && this.oktaClient && this.oktaClient.tenantId && this.okta_client && this.okta_attemptId)
			this.auth.authorize(undefined, {
				customParams:{
					'login_hint': this.login_hint
				}
			});
	}

	public getOktaClient(client: string): any {
		let oktaClients: Array<any> = ENV.config['Okta'];
		for(let i = 0; i < oktaClients.length; i ++){
			if(oktaClients[i].client == client) return oktaClients[i];
		}
	}
}
